export const en = {
  // Navigation
  nav: {
    home: 'Home',
    services: 'Services',
    about: 'About',
    contact: 'Contact',
    implants: 'Implants',
    veneers: 'Veneers',
    composite: 'Composite Build-up',
    technology: 'Technologies',
    book: 'Booking',
    emergency: 'Emergency',
    privacyPolicy: 'Privacy Policy',
    legalNotice: 'Legal Notice',
    admin: 'Admin'
  },

  // Header
  header: {
    logoText: "SeaDent Mallorca",
    phone: "603 31 96 48",
    whatsapp: "WhatsApp",
    languageToggle: "DE",
    reviews: {
      rating: "5.0",
      count: "470+ reviews",
      google: "Google Reviews"
    }
  },

  // Common
  common: {
    loading: 'Loading...',
    error: 'An error occurred',
    save: 'Save',
    cancel: 'Cancel',
    close: 'Close',
    edit: 'Edit',
    delete: 'Delete',
    clear: 'Clear',
    refresh: 'Refresh',
    search: 'Search',
    filter: 'Filter',
    actions: 'Actions',
    status: 'Status',
    date: 'Date',
    time: 'Time',
    email: 'Email',
    phone: 'Phone',
    notes: 'Notes',
    created: 'Created',
    updated: 'Updated',
    name: 'Name',
    description: 'Description',
    duration: 'Duration',
    color: 'Color',
    yes: 'Yes',
    no: 'No',
    confirm: 'Confirm',
    minutes: 'minutes',
    bookNow: 'Book Now'
  },

  // Cookie Consent
  cookieConsent: {
    title: "Cookie Settings",
    description: "We use cookies to improve your experience on our website. By using our website, you agree to our cookie policy.",
    acceptAll: "Accept All",
    acceptNecessary: "Only Necessary",
    settings: "Settings",
    save: "Save Settings",
    close: "Close",
    privacyPolicy: "Privacy Policy",
    categories: {
      necessary: {
        title: "Necessary",
        description: "These cookies are required for the website to function and cannot be disabled."
      },
      preferences: {
        title: "Preferences",
        description: "These cookies allow the website to remember choices you have made."
      },
      statistics: {
        title: "Statistics",
        description: "These cookies help us understand how visitors interact with the website."
      },
      marketing: {
        title: "Marketing",
        description: "These cookies are used to provide visitors with relevant ads and marketing campaigns."
      }
    }
  },

  // Admin
  admin: {
    title: 'Admin Dashboard',
    login: 'Login',
    logout: 'Logout',
    dashboard: 'Dashboard',
    username: 'Username',
    password: 'Password',
    loginButton: 'Sign In',
    loginError: 'Invalid credentials',
    loginRequired: 'Please log in to access the admin panel',
    welcome: 'Welcome to the Admin Dashboard',
    overview: 'Overview',
    quickActions: 'Quick Actions',
    recentActivity: 'Recent Activity',
    systemStatus: 'System Status',
    googleCalendarStatus: 'Google Calendar',
    databaseStatus: 'Database',
    connected: 'Connected',
    disconnected: 'Disconnected',
    healthy: 'Healthy',
    error: 'Error'
  },

  // Calendar
  calendar: {
    title: 'Appointment Calendar',
    next: 'Next',
    previous: 'Previous',
    today: 'Today',
    month: 'Month',
    week: 'Week',
    day: 'Day',
    noEvents: 'No appointments in this time range',
    filterBy: 'Filter by',
    allProviders: 'All Providers',
    allProcedures: 'All Procedures',
    allOperatories: 'All Operatories',
    refresh: 'Refresh Calendar',
    googleCalendarSync: 'Syncing...'
  },

  // Appointments
  appointments: {
    title: 'Appointments',
    create: 'Create Appointment',
    edit: 'Edit Appointment',
    update: 'Update Appointment',
    view: 'View Appointment',
    delete: 'Delete Appointment',
    cancel: 'Cancel Appointment',
    confirm: 'Confirm',
    completed: 'Mark Complete',
    noShow: 'No Show',
    patient: 'Patient',
    provider: 'Provider',
    procedure: 'Procedure',
    operatory: 'Operatory',
    date: 'Date',
    time: 'Time',
    startTime: 'Start Time',
    endTime: 'End Time',
    status: 'Status',
    notes: 'Notes',
    language: 'Language',
    total: 'Total Appointments',
    today: 'Today',
    thisWeek: 'This Week',
    thisMonth: 'This Month',
    upcoming: 'Upcoming',
    recent: 'Recent',
    search: 'Search appointments...',
    filters: 'Filters',
    exportToExcel: 'Export to Excel',
    importFromExcel: 'Import from Excel',
    bulkActions: 'Bulk Actions',
    selectAll: 'Select All',
    selectedCount: 'Selected: {count}',
    conflictDetected: 'Schedule conflict detected',
    googleCalendarEvent: 'Google Calendar Event',
    syncWithGoogleCalendar: 'Sync with Google Calendar',
    createGoogleCalendarEvent: 'Create Google Calendar Event',
    updateGoogleCalendarEvent: 'Update Google Calendar Event',
    deleteGoogleCalendarEvent: 'Delete Google Calendar Event'
  },

  // Providers
  providers: {
    title: 'Providers',
    add: 'Add Provider',
    edit: 'Edit Provider',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    specialization: 'Specialization',
    schedule: 'Schedule',
    active: 'Active',
    inactive: 'Inactive',
    workingHours: 'Working Hours',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
    startTime: 'Start Time',
    endTime: 'End Time',
    dayOff: 'Day Off',
    saveSchedule: 'Save Schedule',
    scheduleUpdated: 'Schedule updated successfully'
  },

  // Procedures
  procedures: {
    title: 'Procedures',
    add: 'Add Procedure',
    edit: 'Edit Procedure',
    name: 'Name',
    description: 'Description',
    duration: 'Duration (minutes)',
    price: 'Price',
    category: 'Category',
    color: 'Color',
    active: 'Active',
    inactive: 'Inactive',
    categories: {
      consultation: 'Consultation',
      cleaning: 'Cleaning',
      filling: 'Filling',
      crown: 'Crown',
      implant: 'Implant',
      veneer: 'Veneer',
      extraction: 'Extraction',
      root_canal: 'Root Canal',
      orthodontics: 'Orthodontics',
      surgery: 'Surgery',
      other: 'Other'
    }
  },

  // Operatories
  operatories: {
    title: 'Operatories',
    add: 'Add Operatory',
    edit: 'Edit Operatory',
    name: 'Name',
    description: 'Description',
    equipment: 'Equipment',
    capacity: 'Capacity',
    active: 'Active',
    inactive: 'Inactive',
    location: 'Location',
    floor: 'Floor',
    room: 'Room',
    specialEquipment: 'Special Equipment'
  },

  // Status
  status: {
    scheduled: 'Scheduled',
    confirmed: 'Confirmed',
    completed: 'Completed',
    cancelled: 'Cancelled',
    no_show: 'No Show',
    pending: 'Pending',
    approved: 'Approved',
    rejected: 'Rejected',
    active: 'Active',
    inactive: 'Inactive'
  },

  // Messages
  messages: {
    appointmentCreated: 'Appointment created successfully',
    appointmentUpdated: 'Appointment updated successfully',
    appointmentDeleted: 'Appointment deleted successfully',
    appointmentCancelled: 'Appointment cancelled successfully',
    providerCreated: 'Provider created successfully',
    providerUpdated: 'Provider updated successfully',
    providerDeleted: 'Provider deleted successfully',
    procedureCreated: 'Procedure created successfully',
    procedureUpdated: 'Procedure updated successfully',
    procedureDeleted: 'Procedure deleted successfully',
    operatoryCreated: 'Operatory created successfully',
    operatoryUpdated: 'Operatory updated successfully',
    operatoryDeleted: 'Operatory deleted successfully',
    saveSuccess: 'Changes saved successfully',
    deleteSuccess: 'Item deleted successfully',
    confirmDelete: 'Are you sure you want to delete this item?',
    confirmCancel: 'Are you sure you want to cancel this appointment?',
    conflictDetected: 'A scheduling conflict has been detected',
    googleCalendarSynced: 'Google Calendar synchronized successfully',
    googleCalendarError: 'Error syncing with Google Calendar',
    googleCalendarSync: 'Syncing with Google Calendar...',
    exportSuccess: 'Data exported successfully',
    importSuccess: 'Data imported successfully',
    noDataToExport: 'No data to export',
    invalidFileFormat: 'Invalid file format',
    networkError: 'Network error. Please try again.',
    sessionExpired: 'Session expired. Please log in again.',
    accessDenied: 'Access denied',
    formValidationError: 'Please correct the errors in the form',
    requiredField: 'This field is required',
    invalidEmail: 'Please enter a valid email address',
    invalidPhone: 'Please enter a valid phone number',
    invalidDate: 'Please enter a valid date',
    invalidTime: 'Please enter a valid time',
    startTimeAfterEndTime: 'Start time must be before end time',
    duplicateEntry: 'This entry already exists',
    noResults: 'No results found',
    loadingData: 'Loading data...',
    noDataAvailable: 'No data available'
  },

  // Reports
  reports: {
    title: 'Reports',
    appointmentReport: 'Appointment Report',
    providerReport: 'Provider Report',
    procedureReport: 'Procedure Report',
    revenueReport: 'Revenue Report',
    cancellationReport: 'Cancellation Report',
    noShowReport: 'No Show Report',
    dateRange: 'Date Range',
    startDate: 'Start Date',
    endDate: 'End Date',
    generateReport: 'Generate Report',
    exportReport: 'Export Report',
    printReport: 'Print Report',
    reportGenerated: 'Report generated successfully',
    noDataForReport: 'No data available for the selected criteria',
    totalAppointments: 'Total Appointments',
    completedAppointments: 'Completed Appointments',
    cancelledAppointments: 'Cancelled Appointments',
    noShowAppointments: 'No Show Appointments',
    totalRevenue: 'Total Revenue',
    averageRevenue: 'Average Revenue',
    topProcedures: 'Top Procedures',
    topProviders: 'Top Providers',
    appointmentsByStatus: 'Appointments by Status',
    appointmentsByProvider: 'Appointments by Provider',
    appointmentsByProcedure: 'Appointments by Procedure',
    dailyAppointments: 'Daily Appointments',
    weeklyAppointments: 'Weekly Appointments',
    monthlyAppointments: 'Monthly Appointments'
  },

  // Settings
  settings: {
    title: 'Settings',
    general: 'General',
    notifications: 'Notifications',
    googleCalendar: 'Google Calendar',
    backup: 'Backup',
    users: 'Users',
    clinicName: 'Clinic Name',
    clinicAddress: 'Clinic Address',
    clinicPhone: 'Clinic Phone',
    clinicEmail: 'Clinic Email',
    timezone: 'Timezone',
    language: 'Language',
    dateFormat: 'Date Format',
    timeFormat: 'Time Format',
    currency: 'Currency',
    emailNotifications: 'Email Notifications',
    smsNotifications: 'SMS Notifications',
    reminderTime: 'Reminder Time',
    calendarId: 'Calendar ID',
    apiKey: 'API Key',
    clientId: 'Client ID',
    clientSecret: 'Client Secret',
    testConnection: 'Test Connection',
    connectionSuccessful: 'Connection successful',
    connectionFailed: 'Connection failed',
    backupDatabase: 'Backup Database',
    restoreDatabase: 'Restore Database',
    backupCreated: 'Backup created successfully',
    backupRestored: 'Backup restored successfully',
    addUser: 'Add User',
    editUser: 'Edit User',
    role: 'Role',
    permissions: 'Permissions',
    admin: 'Admin',
    user: 'User',
    viewer: 'Viewer'
  },

  // Booking form
  booking: {
    title: 'Book Your Appointment',
    subtitle: 'Schedule your visit with our experienced dental team',
    form: {
      name: 'Full Name',
      email: 'Email Address',
      phone: 'Phone Number',
      service: 'Service',
      date: 'Preferred Date',
      time: 'Preferred Time',
      message: 'Additional Notes',
      language: 'Preferred Language',
      submit: 'Book Appointment',
      submitting: 'Submitting...',
      success: 'Your appointment request has been submitted successfully!',
      error: 'There was an error submitting your request. Please try again.',
      required: 'This field is required'
    },
    services: {
      consultation: 'Consultation',
      cleaning: 'Cleaning',
      filling: 'Filling',
      crown: 'Crown',
      implant: 'Implant',
      veneer: 'Veneer',
      extraction: 'Extraction',
      root_canal: 'Root Canal',
      orthodontics: 'Orthodontics',
      surgery: 'Surgery',
      other: 'Other'
    },
    languages: {
      english: 'English',
      german: 'German',
      spanish: 'Spanish',
      russian: 'Russian'
    },
    times: {
      morning: '9:00 AM',
      midMorning: '10:00 AM',
      lateMorning: '11:00 AM',
      noon: '12:00 PM',
      afternoon: '2:00 PM',
      midAfternoon: '3:00 PM',
      lateAfternoon: '4:00 PM',
      evening: '5:00 PM'
    }
  },

  // Emergency
  emergency: {
    title: 'Dental Emergency',
    subtitle: 'We are here to help you 24/7',
    intro: 'If you are experiencing a dental emergency, please contact us immediately. Our emergency team is available around the clock to provide you with the care you need.',
    call: 'Call Now',
    whatsapp: 'WhatsApp',
    cta: 'Call 603 31 96 48',
    details: [
      {
        title: 'Availability',
        description: 'Our emergency team is available 24 hours a day, 365 days a year, including weekends and holidays.'
      },
      {
        title: 'Contact',
        description: 'Call us at 603 31 96 48 for immediate assistance. We also accept WhatsApp messages.'
      },
      {
        title: 'Common Emergencies',
        description: 'We treat severe tooth pain, broken teeth, knocked-out teeth, and other dental traumas.'
      },
      {
        title: 'Service',
        description: 'We provide immediate pain relief and long-term solutions using the latest dental technology.'
      }
    ],
    common: {
      title: 'Common Dental Emergencies',
      toothache: 'Severe Toothache',
      broken: 'Broken or Chipped Tooth',
      knocked: 'Knocked Out Tooth',
      bleeding: 'Bleeding Gums',
      swelling: 'Facial Swelling',
      lost: 'Lost Filling or Crown'
    },
    instructions: {
      title: 'What to Do',
      toothache: 'Rinse with warm salt water and take over-the-counter pain medication.',
      broken: 'Save any pieces and rinse your mouth with warm water.',
      knocked: 'Handle the tooth by the crown, not the root. Keep it moist.',
      bleeding: 'Apply gentle pressure with a clean cloth or gauze.',
      swelling: 'Apply cold compress to the outside of your cheek.',
      lost: 'Keep the area clean and avoid chewing on that side.'
    },
    // === Designer redesign v2 (redesign emergency/DESIGN.md) ===
    v2: {
      heroBadge: 'AVAILABLE NOW • 24/7',
      heroAccent: 'We are here for you.',
      heroIntro: 'If you are experiencing severe pain, dental trauma, or a broken tooth, our expert emergency team provides immediate, empathetic care 365 days a year.',
      callBtn: 'CALL 603 31 96 48',
      whatsappBtn: 'WHATSAPP US',
      stats: {
        availability: 'Availability',
        daysAYear: 'Days a Year',
        responseTime: 'Response Time',
        rating: 'Patient Rating',
      },
      common: {
        title: 'Common Dental Emergencies',
        intro: 'Immediate attention is vital for long-term dental health. We treat all forms of urgent dental trauma with clinical excellence.',
        eyebrow: 'Expert Care in Palma',
        cards: [
          {
            title: 'Severe Tooth Pain',
            description: 'Pulsing or sharp pain often indicates infection or nerve damage requiring immediate relief.',
            checks: ['Immediate diagnostics', 'Root canal therapy'],
          },
          {
            title: 'Dental Trauma',
            description: 'Broken, chipped, or knocked-out teeth from accidents require swift action to save the tooth.',
            checks: ['Emergency reconstruction', 'Reimplantation service'],
          },
          {
            title: 'Abscess & Infection',
            description: 'Swelling and fever are signs of severe dental infections that need antibiotic or surgical intervention.',
            checks: ['Infection drainage', 'Pain management'],
          },
        ],
      },
      process: {
        title: 'What to do in an emergency?',
        steps: [
          {
            title: 'Call us immediately',
            description: 'Contact 603 31 96 48 right away. Briefly explain your symptoms so we can prepare for your arrival.',
          },
          {
            title: 'First aid measures',
            description: 'For pain: cool the area from outside. For a broken tooth: keep the fragment in milk or saliva.',
          },
          {
            title: 'Visit our clinic',
            description: 'Head to Avenida de Jaime III № 3, Palma. We maintain a central location for rapid accessibility.',
          },
        ],
      },
      location: {
        eyebrow: 'Our Practice',
        title: 'SeaDent Mallorca',
        intro: 'Located in the heart of Palma, our clinic combines a Mediterranean atmosphere with state-of-the-art medical technology.',
        addressLine1: 'Avenida de Jaime III № 3',
        addressLine2: '07012 Palma de Mallorca',
        hoursLabel: 'Mon – Fri: 09:00 – 18:00',
        emergencyHours: 'Emergency phone: available 24/7',
        directions: 'Get directions',
      },
      finalCta: {
        title: 'We are here for you.',
        intro: 'Dental pain can be overwhelming. Our empathetic team is ready to provide the relief and expertise you deserve — your smile is in the best hands.',
        button: 'URGENT CALL: 603 31 96 48',
      },
    },
  },

  // Hero Section
  hero: {
    title: 'SeaDent Mallorca: Your Smile Matters.',
    subtitle: 'Modern dentistry with empathy.',
    description: 'Experience world-class dental care in the heart of Mallorca. Our modern clinic combines German precision with Mediterranean warmth.',
    cta: 'Book Appointment Online',
    emergency: 'Emergency Call',
    makeover: {
      title: 'Smile Makeover with Composite',
      subtitle: 'Direct freehand layering technique – minimally invasive and naturally beautiful.',
      cta: 'Learn more'
    },
    rotation: {
      on: 'Rotation: on',
      off: 'Rotation: off'
    },
    scrollMore: 'Learn more',
    banner: {
      title: "Experience personalized comfort",
      subtitle: "(and learn why our patients love to come back)",
      buttons: {
        cosmetic: "Cosmetic Dentistry",
        pediatric: "Pediatric Dentistry",
        general: "General Dentistry",
        whitening: "Teeth Whitening"
      }
    }
  },

  // Booking Wizard
  bookingWizard: {
    steps: {
      treatment: "What type of appointment?",
      insurance: "How would you like to pay?",
      dateTime: "Choose preferred date & time"
    },
    treatments: {
      cleaning: "Professional Dental Cleaning + Exam (Doctor)",
      returningCleaning: "Returning Patient Cleaning (RDH) + Exam (Doctor)",
      consultation: "General Dental Consultation (Doctor)",
      cosmetic: "Cosmetic Dental Consultation (Doctor)",
      secondOpinion: "Second Opinion Dental Consultation (Doctor)",
      emergency: "Emergency Dental Appointment (X-Rays + Doctor Exam)",
      whitening: "Professional Teeth Whitening Treatment",
      botox: "Botox Consultation (Doctor)",
      tmj: "TMJ (Jaw Pain) Consultation (Doctor)",
      pediatric: "Pediatric Dentistry (Children's Dental Care)"
    },
    insurance: {
      search: "Enter your insurance",
      privatePay: "Private pay",
      privatePayDesc: "Self-pay · no insurance required",
      withInsurance: "Via my insurance",
      withInsuranceDesc: "Enter insurance name"
    },
    navigation: {
      back: "Back",
      next: "Next",
      close: "Close"
    },
    getDirections: "Get directions",
    instantBookingBy: "Instant booking by"
  },

  // Services Section
  services: {
    title: 'Our Services',
    subtitle: 'Comprehensive Dental Care',
    implants: {
      title: 'Dental Implants',
      description: 'Permanent solution for missing teeth with titanium implants'
    },
    veneers: {
      title: 'Veneers',
      description: 'Transform your smile with custom porcelain veneers'
    },
    cleaning: {
      title: 'Professional Cleaning',
      description: 'Thorough cleaning and prevention for optimal oral health'
    },
    crown: {
      title: 'Crowns & Bridges',
      description: 'Restore damaged teeth with high-quality crowns and bridges'
    },
    orthodontics: {
      title: 'Orthodontics',
      description: 'Straighten your teeth with modern orthodontic treatments'
    },
    surgery: {
      title: 'Oral Surgery',
      description: 'Expert surgical procedures in our modern operating rooms'
    }
  },

  // Treatments Section
  treatments: {
    title: "Treatments: Your Smile in the Best Hands",
    intro: "Our treatments at SeaDent Mallorca cover the entire spectrum of modern dentistry – from prevention to aesthetic perfection. With advanced technology and empathetic care, we ensure your oral health and a radiant smile.",
    cta: "Book appointment now",
    categories: [
      {
        title: "Prevention and Prophylaxis",
        description: "Regular check-ups and preventive measures for long-term oral health. We focus on individual consultation and modern diagnostics.",
        treatments: [
          {
            title: "Check-up and Consultation",
            description: "Comprehensive examinations and personal recommendations for healthy teeth."
          },
          {
            title: "Professional Dental Cleaning",
            description: "Thorough removal of dental plaque for a clean and fresh feeling."
          },
          {
            title: "Fillings",
            description: "High-quality fillings that restore your teeth aesthetically and functionally."
          },
          {
            title: "Children's Prophylaxis",
            description: "Child-friendly prevention to protect your little ones' teeth in a playful way."
          }
        ]
      },
      {
        title: "Pain Therapy",
        description: "Pain-free treatments through gentle techniques and the latest technologies. Your well-being is the focus of every session.",
        treatments: [
          {
            title: "Pain Treatment",
            description: "Fast and effective relief from dental pain, individually tailored to you."
          },
          {
            title: "Tooth Extraction",
            description: "Gentle removal of teeth when no other solution is possible."
          },
          {
            title: "Root Canal Treatment",
            description: "Precise endodontics to save inflamed teeth and relieve pain."
          },
          {
            title: "TMJ Problems",
            description: "Targeted therapy for temporomandibular joint (TMJ) problems for better quality of life."
          }
        ]
      },
      {
        title: "Periodontitis",
        description: "Professional treatment of gum disease for stable oral health. Early measures prevent long-term damage.",
        treatments: [
          {
            title: "Treatment Measures",
            description: "Professional cleaning and therapies to effectively combat gum inflammation."
          }
        ]
      },
      {
        title: "For a Perfect Smile (Aesthetics)",
        description: "Aesthetic solutions for a confident smile, tailored to your wishes. Our methods are gentle and effective.",
        treatments: [
          {
            title: "Composite Build-up",
            description: "Direct aesthetic build-up in a single visit – no drilling, freehand layering technique."
          },
          {
            title: "Invisalign",
            description: "Transparent aligners for discreet and comfortable tooth correction."
          },
          {
            title: "Teeth Whitening",
            description: "Gentle whitening of your teeth for a radiant, white smile."
          },
          {
            title: "Grinding Guards",
            description: "Custom-made guards to prevent teeth grinding and protect your teeth."
          },
          {
            title: "Veneers",
            description: "Ultra-thin ceramic shells for a perfect and natural appearance of your teeth."
          },
          {
            title: "Crowns and Bridges",
            description: "High-quality dental prosthetics for function and aesthetics of damaged teeth."
          }
        ]
      },
      {
        title: "Implants",
        description: "State-of-the-art implant technology for natural and permanent tooth replacement. Our implants offer you comfort and security.",
        treatments: [
          {
            title: "Single Implants",
            description: "Replacement of individual teeth with high-quality implants for a natural feeling."
          },
          {
            title: "Multiple Implants",
            description: "Comprehensive implant solutions for larger tooth gaps or complete tooth rows."
          },
          {
            title: "Immediate Implants",
            description: "Implants with immediate loading for quick restoration of your chewing function."
          }
        ]
      }
    ]
  },

  // Benefits Section
  benefits: {
    title: 'Your benefits: Excellence, comfort and a smile that shines.',
    items: [
      {
        title: 'Experience and Expertise',
        description: 'Qualified dentists with continuous education and training.'
      },
      {
        title: 'Cutting-edge Technology',
        description: 'Precise treatments with digital X-rays and innovative equipment.'
      },
      {
        title: 'Patient-centered Care',
        description: 'Empathetic treatment as you would expect from a friend.'
      },
      {
        title: 'Mediterranean Atmosphere',
        description: 'A relaxed environment inspired by the beauty of Mallorca.'
      },
      {
        title: 'Multilingual Service',
        description: 'Treatment in German, English, Spanish, and Russian.'
      },
      {
        title: 'Central Location',
        description: 'Easily accessible in the heart of Palma de Mallorca.'
      }
    ]
  },

  // Approach Section
  approach: {
    title: 'Dentistry reimagined: Your comfort, our commitment.',
    text: 'At SeaDent, we want your visit to the dentist to be something special. Our mission is to offer you not only medically excellent treatments, but also an atmosphere where you feel relaxed and understood. This means for us:',
    points: [
      'We listen to you: Your wishes and needs are at the center of our care. We take time for personalized consultation.',
      'Relaxation and pain-free treatments: Using state-of-the-art techniques and focusing on your well-being, we make treatments as comfortable as possible.',
      'Transparency creates trust: We explain every step of your treatment clearly and understandably, so you feel confident.'
    ]
  },

  // Team Section
  team: {
    title: 'Our Team',
    subtitle: 'Experts for Your Smile',
    description: 'Our experienced team of dentists and dental hygienists is dedicated to providing you with the best possible care.',
    cta: 'Meet Our Team'
  },

  // Experience Section
  experience: {
    title: 'Your moments of well-being at SeaDent Mallorca.',
    text: 'At SeaDent, it\'s about more than just dentistry – we want your visit to become a moment of relaxation. Our practice combines cutting-edge treatments with an atmosphere inspired by the tranquility and beauty of Mallorca.',
    points: [
      'Welcoming atmosphere with Mediterranean colors and natural light.',
      'Friendly and empathetic team that warmly welcomes you.',
      'Short waiting times thanks to efficient practice management.',
      'Comfortable waiting areas with WiFi, drinks and plants.',
      'Relaxing details like soothing music during treatment.'
    ]
  },

  // Social Proof Section
  socialProof: {
    title: "What our patients say",
    reviews: [
      {
        text: "Professionally top-notch, humanly great, you really feel well taken care of here ❤️. A huge thank you to the dentist and the whole team. This is exactly how I imagine a modern, warm practice to be 🦷🤗.",
        author: "Marcel"
      },
      {
        text: "I have never experienced such a dedicated, warm, and honest dentist. He always takes a lot of time – even outside of normal practice hours – and is always there for his patients. The treatments are professional and carried out with a lot of empathy. Even after the appointment, he takes care of the follow-up and wants to know how you are doing – that is anything but a matter of course. An absolutely great dentist whom you can trust completely. Absolute recommendation!",
        author: "Stefanie"
      },
      {
        text: "Top dentist!!! Of course, I got extreme toothache right during my holiday after a filling that was a few weeks ago. Waiting until I could go to my dentist back home in Germany was not possible. I got an appointment with Jan D. Heiringhoff immediately. He is super likeable, listens, asks questions, and did the necessary root canal treatment perfectly. My dentist in Germany later said that he did a great job with the root canal treatment. I had no problems or even pain during or after the treatment. I can highly recommend him!",
        author: "Hendrik"
      },
      {
        text: "I was really very happy to receive a quick and uncomplicated answer after a sleepless night due to acute toothache. The treatment was also prompt and professional. It's nice that there are still doctors who also work on Saturdays and are still very friendly and competent. Thank you very much.",
        author: "T."
      },
      {
        text: "Immediate (!) and professional emergency treatment. Transparent and at eye level. Many thanks to the team, I felt very well taken care of. SUPPLEMENT (a few months later): Back in the practice and this time took advantage of bleaching. Everything professional and friendly. Simply a recommendable practice! 👍",
        author: "Hubert"
      },
      {
        text: "I was received and treated in a super friendly manner. Dr. Heiringhoff took a lot of time and explained everything in detail. At my request, he took 2 X-rays of my new crown. I was afraid I had a root infection. That wasn't the case and I was able to leave with peace of mind. I can absolutely recommend Dr. Heiringhoff. Thank you for the quick help on a Sunday ☺️.",
        author: "Elke"
      },
      {
        text: "To be honest, my teeth looked really 'crack' before – so much so that I preferred to look serious in photos rather than smile. But then came Jan! The guy turned my teeth into a smile that's something to behold. Super relaxed, zero dentist fear, and real attention to detail. Now I'm grinning again as if I'd just stepped out of a toothpaste advert. Thanks, Jan – you're my tooth hero!",
        author: "Patrick"
      },
      {
        text: "Many thanks for the quick help. Had a dental emergency during my holiday. Got an appointment immediately, where I was super advised and treated. Recommendation from the heart.",
        author: "Simone"
      }
    ]
  },

  // Technologies Section
  technologies: {
    title: 'Modern Technology',
    subtitle: 'State-of-the-Art Equipment',
    intro: 'At SeaDent, we prioritize individual, pleasant, and painless dentistry through the use of cutting-edge technology.',
    sections: [
      {
        title: 'Digital Dentistry',
        description: 'Digital impressions and 3D imaging for precise diagnostics and treatment planning.',
        benefits: [
          'Fast and convenient digital tooth capture.',
          'Significantly higher comfort than with impressions.',
          'Possibility to visualize your treatment results.',
          'Contributes to faster and more pleasant treatment.'
        ]
      },
      {
        title: 'Dental Laser: The Healing Light',
        description: 'A dental laser is a versatile instrument that replaces many conventional tools and supports healing. It operates precisely, efficiently, and safely. Benefits of the Dental Laser for you:',
        benefits: [
          'Supports the healing of gums, bone, and more.',
          'Enables minor surgical procedures.',
          'Helps in the sterilization of root canals.',
          'Used for hemostasis (stopping bleeding) during procedures.',
          'Effective treatment for canker sores and herpes.',
          'Supports periodontitis treatment.',
          'Helps in desensitizing sensitive tooth necks.'
        ]
      },
      {
        title: 'Implant Technology',
        description: 'Advanced implant systems for optimal integration and long-term success.',
        benefits: [
          'High-quality biocompatible materials',
          'Computer-guided planning for maximum safety',
          'Long-lasting and natural-looking results'
        ]
      },
      {
        title: 'Dental Microscope',
        description: 'Microscopic precision for endodontic treatments and fine surgical procedures.',
        benefits: [
          'Maximum accuracy in details',
          'Higher success rates for root canal treatments',
          'Preservation of as much natural tooth structure as possible'
        ]
      }
    ],
    conclusion: 'By combining these modern technologies with our focus on trust and transparency, you will experience dentistry at SeaDent that is professional, pleasant, and personal.'
  },

  cta: {
    title: 'Experience dentistry that puts you first.',
    text: 'Ready for a dental practice that combines professionalism with Mediterranean comfort? Book your appointment at SeaDent Mallorca and discover a new kind of dentistry – we look forward to welcoming you to Palma!',
    bookButton: 'Book Online Appointment',
    callButton: 'Call Us',
    visitInfo: 'Visit us: Avenida de Jaime III № 3, Palma, Mallorca.'
  },

  // Footer
  footer: {
    legal: {
      title: 'Legal Notice',
      privacy: 'Privacy Policy',
      cookieSettings: 'Cookie Settings'
    },
    links: {
      title: 'Navigation',
      home: 'Home',
      contact: 'Contact',
      book: 'Book Appointment'
    },
    contact: {
      title: 'Contact Information',
      practice: 'SeaDent Mallorca',
      address: 'Avenida de Jaime III, № 3',
      city: '07012 Palma de Mallorca',
      owner: 'Inhaber: Jan D. Heiringhoff',
      phone: '603 31 96 48',
      whatsapp: 'WhatsApp: 603 31 96 48',
      email: 'info@seadent.es',
      hours: 'Mon-Fri: 09:00 - 18:00'
    },
    copyright: '© {year} SeaDent Mallorca. All rights reserved.'
  },
  implants: {
    title: 'Implants – For a Better Quality of Life',
    intro: 'Dental implants are the most modern and natural way to replace missing teeth. They offer not only perfect aesthetics but also give you back the feeling and security of your own teeth. In our practice in Palma, we rely on the highest quality standards and state-of-the-art procedures.',
    benefitsTitle: "Benefits of Implants",
    benefit1: "Natural look and feel, comparable to your own teeth",
    benefit2: "Improved chewing function and speaking ability",
    benefit3: "Long-lasting solution with a high success rate",
    benefit4: "Preservation of jawbone structure",
    qualityTitle: "Highest Quality and Precision",
    quality: "We use only high-quality materials and state-of-the-art digital planning procedures. This guarantees you a precise and long-lasting result that fits you perfectly.",
    experienceTitle: "Pleasant Treatment Experience",
    experience: "Thanks to minimally invasive techniques and gentle anesthesia, treatment with us is particularly gentle. Our goal is for you to feel comfortable and safe throughout the process.",
    processTitle: "The Path to Your New Implants",
    step1Title: "Consultation",
    step1: "Detailed discussion and individual planning",
    step2Title: "Implantation",
    step2: "Gentle procedure under local anesthesia",
    step3Title: "Healing",
    step3: "Integration of the implant with the jawbone",
    step4Title: "Prosthesis",
    step4: "Creation and insertion of the individual tooth replacement"
  },
  veneers: {
    title: 'Veneers – For Your Radiant Smile',
    intro: 'Ultra-thin ceramic shells, known as veneers, offer an elegant solution to permanently correct minor aesthetic imperfections on the front teeth. Whether it is discoloration, small gaps, or slight misalignments – we help you achieve a harmonious and natural smile.',
    imageAlt: "Veneer treatment at SeaDent Mallorca",
    description: "Veneers are individually manufactured shells that are firmly bonded to the tooth surface. They are characterized by their high biocompatibility and aesthetics that are hard to distinguish from natural teeth. In just a few sessions, we transform your smile and give you new self-confidence."
  },
  composite: {
    title: 'Direct Composite Restoration – Your New Smile in a Single Visit',
    intro: 'Direct, additive build-up of your teeth with tooth-coloured composite in freehand layering technique – no drilling, no laboratory, with a visible result the same day.',
    heroAlt: 'Before/after comparison of composite restoration at SeaDent Mallorca',
    heroCaption: 'Before and after, side by side. Composite build-up on the upper anterior teeth (right side of the image) shown next to the untreated side on the left. Shape, length, shade and brightness are tailored individually to your wishes.',
    whatIsTitle: 'What is direct composite restoration?',
    whatIsBody: 'Direct composite restoration is a modern, minimally invasive aesthetic dental procedure. We reshape the form, length, colour and position of your teeth – without grinding, without lab impressions and without temporaries. A high-grade, tooth-coloured composite is applied directly onto the tooth in successive thin layers, sculpted by hand and cured with polymerisation light.',
    whatIsResult: 'You see the result the same day you leave the practice.',
    distinctionTitle: 'Important: this is not a veneer',
    distinctionBody: 'Conventional ceramic veneers require the dentist to grind down healthy tooth structure to make room for the shell. Our procedure is purely additive: we add material without reducing the natural tooth – and the result is fully reversible.',
    indicationsTitle: 'Who is it for?',
    indications: [
      { title: 'Anterior aesthetic corrections', body: 'Chipped edges, uneven lengths, asymmetries and shape anomalies on visible front teeth.' },
      { title: 'Diastema closure', body: 'Gaps of up to approximately 6–7 mm can be closed without orthodontics.' },
      { title: 'Reconstruction of worn teeth', body: 'Restoring original tooth shape and length in cases of bruxism, erosion or age-related abrasion.' },
      { title: 'Additive smile makeover', body: 'Harmonious redesign of multiple anterior teeth in a single appointment.' }
    ],
    whyTitle: 'What makes our method distinctive',
    whyBuildupAlt: 'Photoreal macro of composite layering technique with light curing',
    why: [
      { title: 'Result in a single visit', body: '30–60 minutes per tooth. A complete anterior makeover (6–8 teeth) is completed in one appointment. No lab, no second visit, no temporary restoration.' },
      { title: 'Freehand layering technique', body: 'Dentin and enamel masses are sculpted in multiple layers – just like a natural tooth. The result has genuine depth, opalescence and light refraction.' },
      { title: 'Tissue-preserving & reversible', body: 'Your natural tooth substance remains fully intact. All future treatment options remain open.' }
    ],
    processTitle: 'The procedure step by step',
    processIllustrationAlt: 'Illustration of composite layering with polymerisation light',
    process: [
      { title: 'Consultation & analysis', body: 'Clinical examination, occlusal assessment, discussion of your wishes.' },
      { title: 'Shade & shape selection', body: 'Choice of composite shades for dentin and enamel layers.' },
      { title: 'Preparation', body: 'Surface cleaning, rubber dam isolation, adhesive conditioning.' },
      { title: 'Layered build-up', body: 'Polychromatic layering with light curing of every layer.' },
      { title: 'Finishing & high-gloss polishing', body: 'Anatomical micro-texture and natural lustre.' },
      { title: 'Final check & result', body: 'Visual control, bite check, handover.' }
    ],
    aftercareTitle: 'After the treatment & care',
    aftercare: [
      'No downtime – you can eat and speak immediately',
      'First 24–48 hours: avoid strongly staining foods and drinks (coffee, red wine, tea, curry, berries)',
      'Care like your natural teeth – brush twice daily, interdental cleaning, regular professional hygiene',
      'Avoid chewing ice or opening packaging with your front teeth',
      'For bruxism patients: a custom night guard for protection'
    ],
    longevityTitle: 'Longevity',
    longevityBody: 'With good oral hygiene and regular professional care, direct composite restorations can last up to 20 years. Composite can be re-polished, extended and repaired locally – no full replacement required.',
    benefitsTitle: 'Benefits at a glance',
    benefits: [
      { label: 'Single visit', value: 'Visible result immediately' },
      { label: 'No drilling', value: '100 % of your natural tooth preserved' },
      { label: 'Layered build-up', value: 'Natural appearance, indistinguishable from real teeth' },
      { label: 'Reversible', value: 'All future treatment options remain open' },
      { label: 'Repairable', value: 'Small corrections without full replacement' },
      { label: 'Fair pricing', value: 'Significantly more affordable than lab-made restorations' }
    ],
    faqTitle: 'Frequently asked questions',
    faq: [
      { q: 'Is the treatment painful?', a: 'No. Because no drilling is involved, anaesthesia is usually unnecessary.' },
      { q: 'How long does an appointment take?', a: '30–60 minutes per tooth. A full smile makeover is scheduled in one day.' },
      { q: 'Can people tell it is not my own tooth?', a: 'With correctly executed layering using dentin and enamel masses, the composite is visually indistinguishable from natural enamel.' },
      { q: 'How do I care for the restored teeth?', a: 'Like your natural teeth. Professional cleanings every six months are important.' },
      { q: 'Will the material discolour?', a: 'Modern composite is highly colour-stable. Minor surface discolouration can usually be removed by polishing.' },
      { q: 'How long will the result last?', a: 'Up to 20 years with proper care. Repairs are always possible without replacing the whole restoration.' },
      { q: 'What if a piece chips off?', a: 'We repair the affected area locally, without replacing the entire restoration.' },
      { q: 'Am I a suitable candidate?', a: 'We will clarify this in a personal consultation. In cases of severe wear or bite problems we will openly discuss the most appropriate method.' },
      { q: 'What is the cost?', a: 'Depends on the number and complexity of teeth involved. You receive a written quote before treatment begins.' }
    ],
    ctaTitle: 'Ready for your new smile?',
    ctaBody: 'Schedule a personal consultation. We listen, examine carefully and tell you honestly what is achievable.',
    ctaButton: 'Book your consultation online',
    ctaCall: 'Or call us'
  },

  // Contact
  contact: {
    title: 'Contact Us',
    subtitle: 'Get in Touch',
    contactInfo: 'Contact Information',
    address: 'Address',
    phone: 'Phone',
    email: 'Email',
    emergencyTitle: 'Emergency Service',
    emergencyText: 'For dental emergencies, a 24/7 service is available',
    appointment: 'Appointment',
    findUsTitle: 'Where to find us',
    directionsButton: 'Get Directions',
    transportTitle: 'How to get here',
    publicTransport: 'Public Transport',
    publicTransportInfo: 'We are located in the heart of Palma, near major bus stops on Jaime III.',
    byCar: 'By Car',
    byCarInfo: 'Several public car parks are nearby, including Parking Vía Roma and El Corte Inglés.',
    form: {
      name: 'Name',
      email: 'Email',
      subject: 'Subject',
      message: 'Message',
      send: 'Send Message',
      success: 'Message sent successfully!',
      error: 'Error sending message. Please try again.'
    }
  }
}; 